export default __webpack_public_path__ + "static/media/KZ.Т.12.2480 black.b9ed946e.svg";